import React, { createContext, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [user, setUser] = useState(
        sessionStorage.getItem("authToken") || null
    );

    const login = (authToken) => {
        sessionStorage.setItem("authToken", authToken);
        setUser(authToken);

        const redirectPath = location.state?.path || "/dashboard";
        navigate(redirectPath, { replace: true });
    };

    const logout = () => {
        sessionStorage.clear();
        setUser(null);
        navigate("/login", { replace: true });
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);